import React from "react";

type Stat = {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  onClick?: () => void;
};

type StatCardGridProps = {
  stats?: Stat[];
  renderExtraCard?: (() => React.ReactNode) | null;
};

const StatCardGrid: React.FC<StatCardGridProps> = ({
  stats = [],
  renderExtraCard = null,
}) => {
  const statCount = stats.length + (renderExtraCard ? 1 : 0);

  const getColumnClass = () => {
    if (statCount === 6) return "xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6";
    if (statCount === 5) return "xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5";
    if (statCount === 4) return "xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4";
    if (statCount === 3) return "xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3";
    if (statCount === 2) return "xs:grid-cols-1 sm:grid-cols-2";
    return "xs:grid-cols-1";
  };

  return (
    <div className={`grid ${getColumnClass()} gap-4 mb-6 mt-4 justify-center`}>
      {stats.map((stat, idx) => (
        <div
          key={idx}
          onClick={stat.onClick}
          tabIndex={stat.onClick ? 0 : undefined}
          role={stat.onClick ? "button" : undefined}
          onKeyDown={(e) => {
            if (stat.onClick && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              stat.onClick();
            }
          }}
          className={`bg-surface text-foreground p-4 rounded-3xl flex flex-col items-center justify-center gap-2 text-center shadow-md hover:shadow-lg transition-all duration-300 ease-in-out border border-border ${stat.onClick ? 'cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-primary' : ''}`}
        >
          <div 
            className="w-12 h-12 flex items-center justify-center rounded-full text-black transition-transform duration-300 hover:scale-110"
            style={{ backgroundColor: 'var(--color-stat-accent)' }}
          >
            {stat.icon}
          </div>
          <div className="text-lg text-foreground mt-1 font-medium">{stat.label}</div>
          <div 
            className="text-3xl font-bold"
            style={{ color: 'var(--color-stat-accent)' }}
          >
            {stat.value}
          </div>
        </div>
      ))}
      {renderExtraCard && renderExtraCard()}
    </div>
  );
};

export default StatCardGrid;
